import React from 'react';

import { ErrorBoundaryWrapper } from '~/components/error-boundary-wrapper/ErrorBoundaryWrapper';
import { useQueryParams } from '~/hooks/use-query-params/useQueryParams';
import { queryKeys } from '~/routes/app-paths';
import { INSIGHTS_DRAWER_ID } from '~/views/insights/utils/const';
import { InsightsDrawer } from '~/widgets/insight-widget/components/insight-drawer/InsightsDrawer';

export const InsightsDrawerRender = () => {
  const { params } = useQueryParams();

  if (
    params.activeInsight &&
    params[queryKeys.activeDrawer] === INSIGHTS_DRAWER_ID
  ) {
    return (
      <ErrorBoundaryWrapper showBorder={false}>
        <InsightsDrawer insightId={params.activeInsight} />
      </ErrorBoundaryWrapper>
    );
  }

  return null;
};
